/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_Cat_4Inputs */

const en_mk_context_cat_4 = /** @type {(inputs: Mk_Context_Cat_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitors`)
};

const id_mk_context_cat_4 = /** @type {(inputs: Mk_Context_Cat_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompetitor`)
};

/**
* | output |
* | --- |
* | "Competitors" |
*
* @param {Mk_Context_Cat_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_cat_4 = /** @type {((inputs?: Mk_Context_Cat_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_Cat_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_cat_4(inputs)
	return en_mk_context_cat_4(inputs)
});